module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "topictitle1",
    attrs: {
      "id": "ep2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/nav#nep2"
    }
  }, [_c('span', {
    staticClass: "first_text"
  }, [_vm._v("Epigraph")])])])]), _vm._v(" "), _c('div', {
    staticClass: "epi_group"
  }, [_c('p', {
    staticClass: "epigraph"
  }, [_vm._v("“Humans arose as a fortuitous and contingent outcome of thousands of linked events, any one of which could have occurred differently\n               and sent history on an alternative pathway . . .”\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph_attribution"
  }, [_vm._v("—Stephen Jay Gould, evolutionary biologist")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11f29967","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epigraph.vue
// module id = 69
// module chunks = 0